import createAction from '../utils/createAction'
import * as ActionTypes from '../constants/ActionTypes'

export const setFavouriteScreenings = favouriteScreenings =>
  createAction(ActionTypes.SET_FAVOURITE_SCREENINGS, favouriteScreenings)
